export default __webpack_public_path__ + "static/media/Website-Blogs-Banner-closing-340X340.81ff03a0.jpg";